class ThicknessMessagingSelector extends CustomElement {
  mounted() {
    this.liveFieldset = this.closest('fieldset')

    if (!this.liveFieldset) return

    this.addEventListener('change', this.handleChange.bind(this))
  }

  handleChange(event) {
    const input = event.target
    if (!input || input.type !== 'radio' || !this.liveFieldset) return

    const liveInput = this.liveFieldset.querySelector(`input[name="Thickness"][value="${CSS.escape(input.value)}"]`)
    if (!liveInput) return

    liveInput.checked = true
    liveInput.dispatchEvent(new Event('change', { bubbles: true }))
  }
}

customElements.define('thickness-messaging-selector', ThicknessMessagingSelector)
